export default class Accordions {
    constructor(element) {
      this.el = element;
      this.init();
    }
  
    init() {} 
}